import React, { useMemo, useRef } from 'react';
import { ListItemText, MenuItem, Select } from '@mui/material';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setFilters } from '@/features/table/instantSearchSlice';
import { useInstantSearchOwnerFilters } from '@/hooks/useInstantSearchOwnerFilters';
import { CONSENT_STATUS_OPTIONS } from '@/features/informedConsent/helpers';
import { OverflowChips } from '@/components/OverflowChips';
import { useChipFit } from '@/hooks/useChipFit';

const ALL = 'All';
const CLEAR = 'Clear Filters';

export const InformedConsentStatusSelect = () => {
	const dispatch = useDispatch();
	const { pathname: slug } = useLocation();
	const { filters } = useInstantSearchOwnerFilters();
	const selected = filters?.informedConsentStatus ?? [];

	const allSelected = CONSENT_STATUS_OPTIONS.every((option) => selected.includes(option.value));

	const selectedItems = useMemo(
		() => CONSENT_STATUS_OPTIONS.filter((option) => selected.includes(option.value)),
		[selected],
	);

	const containerRef = useRef();
	const limitTags = useChipFit(containerRef, selectedItems.length);

	const handleChange = (event) => {
		let values = event.target.value;
		if (values.includes(ALL)) {
			values = CONSENT_STATUS_OPTIONS.map((option) => option.value);
		}
		if (values.includes(CLEAR)) {
			values = [];
		}
		dispatch(setFilters({ slug, type: 'informedConsentStatus', values }));
	};

	return (
		<Select
			ref={containerRef}
			multiple
			fullWidth
			displayEmpty
			value={selected}
			onChange={handleChange}
			sx={{ maxHeight: 35, alignItems: 'center' }}
			renderValue={() => (
				<OverflowChips
					items={selectedItems}
					limitTags={limitTags}
					getLabel={(option) => option.label}
				/>
			)}
		>
			<MenuItem value={allSelected ? CLEAR : ALL}>
				<CheckBoxOutlineBlank />
				<ListItemText primary={allSelected ? CLEAR : ALL} />
			</MenuItem>
			{CONSENT_STATUS_OPTIONS.map((option) => (
				<MenuItem key={option.value} value={option.value}>
					{selected.includes(option.value) ? <CheckBox /> : <CheckBoxOutlineBlank />}
					<ListItemText primary={option.label} />
				</MenuItem>
			))}
		</Select>
	);
};
